import Tips from '@/components/Tips'    // 引入组件

const tips = {
  install: function (Vue) {
    Vue.component('ds-tips', Tips)
  }
}

export default tips



// WEBPACK FOOTER //
// ./src/components/js/tips.js